import React from "react";
import { Check, ThumbsUp } from "lucide-react";

const STYLE = {
  thumbs_up: { Icon: ThumbsUp, ring: "bg-sky-400", chip: "bg-sky-500", testId: "celebration-thumbs-up", iconCls: "animate-thumb-wiggle" },
  checkmark: { Icon: Check, ring: "bg-emerald-400", chip: "bg-emerald-500", testId: "celebration-checkmark", iconCls: "" },
};

// Light, non-blocking celebration for everyday wins: pop-in icon, pulsing rings, one-line caption; fades in ~2s.
export default function LightPop({ item }) {
  const s = STYLE[item.celebration] || STYLE.checkmark;
  return (
    <div className="pointer-events-none fixed inset-x-0 top-24 z-[70] flex justify-center px-4" data-testid={s.testId} role="status" aria-live="polite">
      <div className="animate-light-pop flex flex-col items-center">
        <div className="relative flex h-20 w-20 items-center justify-center">
          <span className={`absolute inset-0 rounded-full ${s.ring} animate-pulse-ring`} />
          <span className={`absolute inset-0 rounded-full ${s.ring} animate-pulse-ring`} style={{ "--delay": "0.35s" }} />
          <span className={`relative flex h-16 w-16 items-center justify-center rounded-full ${s.chip} text-white shadow-xl ring-4 ring-white`}>
            <s.Icon className={`h-8 w-8 ${s.iconCls}`} strokeWidth={2.6} />
          </span>
        </div>
        <p className="mt-3 max-w-xs rounded-full bg-white/95 px-4 py-1.5 text-center text-sm font-semibold text-slate-800 shadow-lg backdrop-blur" data-testid="celebration-caption">
          {item.title}
        </p>
      </div>
    </div>
  );
}
